export const KARYAKARTA_CONSTANT = {
  KARYAKARTA_DATA: "/user",
  KARYAKARTA_LIST: "/user/karyakarta/list",
  ADMIN_TOP_KARYAKARTA: "/user/o/dashboard/topk",
  KARYAKARTA_COUNT: "/dashboard/karyakarta/count",
  USER_CHANGE_STATUS: "/user/status",
  TOTAL_COUNT: "/user/total/count",
  CAST: "/cast",
  SUBCAST_WITH_CAST: "/common/subcast",
  USER_CHECK: "/user/check",
};
